
import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import CONSTANTS from '../../constants'

import { CurrentStepSetAction, setListDealersFiltred } from '../../actions/action'
import { headTitleTag, slugify } from '../../helpers/functions'

import fetchApiData from '../apiHandlers/fetchApiData'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'

import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox'

import BodyClassName from 'react-body-classname'
import './home.css'
import markerIconAP from '../../images/AP/pin-peugeot-map.png'
import markerIconMobileAP from '../../images/AP/pin-peugeot-map-mobile.png'
import markerIconActiveAP from '../../images/AP/pin-peugeot-hover.png'
import markerIconActiveMobileAP from '../../images/AP/pin-peugeot-hover-mobile.png'
import clusterIconAP from '../../images/AP/ap-pin-number.png'
import clusterIconAPMobile from '../../images/AP/ap-pin-number-mobile.png'
/* import markerIconAC from '../../images/AC/citroen-pin.svg';
import markerIconActiveAC from '../../images/AC/citroen-pin-hover.svg'; */

import markerIconAC from '../../images/AC/pin-ac-defaut.svg'
import markerIconActiveAC from '../../images/AC/pin-ac-hover.svg'
import clusterIconAC from '../../images/AC/ac-pin-number.svg'
import clusterIconACMobile from '../../images/AC/ac-pin-number-mobile.svg'

import markerIconDS from '../../images/DS/ds-pin-Small.png'
import markerIconActiveDS from '../../images/DS/ds-pin-Big-Hover.png'
import clusterIconDS from '../../images/DS/ds-pin-number.svg'
import clusterIconDSMobile from '../../images/DS/ds-pin-number-mobile.svg'

import markerIconOV from '../../images/OV/pin-ov-defaut.png'
import markerIconActiveOV from '../../images/OV/pin-ov-hover.png'
import clusterIconOV from '../../images/OV/ov-pin-number.png'
import { isEqual } from 'lodash'

var _marker = {}
if (window.siteConfig.currentBrand == 'P') {
  _marker = new Object({
    icon: window.innerWidth <= 800 ? markerIconMobileAP : markerIconAP,
    iconActive: window.innerWidth <= 800 ? markerIconActiveMobileAP : markerIconActiveAP,
    iconCluster: clusterIconAP,
    iconClusterMobile: clusterIconAPMobile,
    size: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(80, 80) : new window.google.maps.Size(120, 120) : false),
    scaledSize: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(80, 80) : new window.google.maps.Size(120, 120) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  })
}

if (window.siteConfig.currentBrand == 'C') {
  _marker = new Object({
    icon: markerIconAC,
    iconActive: markerIconActiveAC,
    iconCluster: clusterIconAC,
    iconClusterMobile: clusterIconACMobile,
    size: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(45, 53) : new window.google.maps.Size(112, 112) : false),
    scaledSize: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(45, 53) : new window.google.maps.Size(112, 112) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  })
}
if (window.siteConfig.currentBrand == 'D') {
  _marker = new Object({
    icon: markerIconDS,
    iconActive: markerIconActiveDS,
    iconCluster: clusterIconDS,
    iconClusterMobile: clusterIconDSMobile,
    size: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(45, 53) : new window.google.maps.Size(50, 50) : false),
    scaledSize: (window.google.maps ? window.innerWidth <= 800 ? new window.google.maps.Size(45, 53) : new window.google.maps.Size(50, 50) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  })
}

if (window.siteConfig.currentBrand == 'V') {
  _marker = new Object({
    icon: markerIconOV,
    iconActive: markerIconActiveOV,
    iconCluster: clusterIconOV,
    size: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
    scaledSize: (window.google.maps ? new window.google.maps.Size(44, 63) : false),
    origin: (window.google.maps ? new window.google.maps.Point(0, 0) : false)
  })
}

const labels = window.labels
const siteConfig = window.siteConfig

const google = window.google
var Gmap
const mapStateToProps = state => state
const mapDispatchToProps = { CurrentStepSetAction, setListDealersFiltred }

const MyMapComponent = withGoogleMap(
  (props) =>
    <GoogleMap
      defaultZoom={(window.innerWidth <= 800 ? 5 : siteConfig.defaultCountryGeo.zoom)}
      ref={props.onMapMounted}
      defaultCenter={props.attDefaultCenter}
      options={props.attOptions}
    >
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        gridSize={(window.innerWidth <= 800 ? 40 : 80)}

        styles={(window.siteConfig.currentBrand == 'P' ? window.innerWidth <= 800 ? [{ textColor: '#ffffff', fontFamily: 'Peugeot', textSize: 10, height: 27, url: _marker.iconClusterMobile, width: 27, anchorIcon: [-10, 10] }] : [{ textColor: '#ffffff', fontFamily: 'Peugeot', textSize: 18, height: 96, url: _marker.iconCluster, width: 117 }]
          : (window.siteConfig.currentBrand == 'C' ? window.innerWidth <= 800 ? [{ textColor: '#57718a', fontFamily: 'Ubuntu', textSize: 14, height: 27, url: _marker.iconClusterMobile, width: 30, anchorIcon: [-10, 8] }] : [{ textColor: '#57718a', fontFamily: 'Ubuntu', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
            : (window.siteConfig.currentBrand == 'D' ? window.innerWidth <= 800 ? [{ textColor: '#fff', fontFamily: 'Roboto', textSize: 10, height: 27, url: _marker.iconClusterMobile, width: 25, anchorIcon: [-10, 8] }] : [{ textColor: '#fff', fontFamily: 'Roboto', textSize: 20, height: 53, url: _marker.iconCluster, width: 53 }]
              : [{ textColor: '#000', fontFamily: 'Opel', textSize: 14, height: 42, url: _marker.iconCluster, width: 46 }])))}
      >
        {props.children}
      </MarkerClusterer>
    </GoogleMap>
)

class HomePageMap extends PureComponent {
  constructor(props) {
    super(props)
    this.getDistanceBetweenPlaces = this.getDistanceBetweenPlaces.bind(this)
    this.markerIsHover = this.markerIsHover.bind(this)
    this.markerNotHover = this.markerNotHover.bind(this)
    this.hideInfoWindow = this.hideInfoWindow.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.isMobile = this.isMobile.bind(this)
    this.state = {
      data: [],
      dealersFiltred: this.props.store.dealersFiltred,
      checkedFilters: this.props.store.filterDealersBy,
      showFiltersPCLCV: false,
      isLoading: false,
      error: null,
      pagination: 9,
      stickyMap: 'notSticky',
      markerHoverd: true,
      map: {
        lat: Number(window.siteConfig.defaultCountryGeo.lat),
        lng: Number(window.siteConfig.defaultCountryGeo.lng)
      }
    }
    this.map = null
    this.markers = {}
  }

  componentDidMount() {
    console.log('did mount')
    this.setState({ isLoading: true })

    // scroll to the top on user arrive to page
    window.scrollTo(0, 0)
    const listDealers = new fetchApiData()
    console.time('dataFetching')
    listDealers.getListDealers().then(
      data => {
        this.setState({
          isLoading: false,
          data: data.d,
        })
        this.props.store.filterDealersBy.length > 0 ? this.filterDealers() : this.setState({ dealersFiltred: data.d })
        this.setState({
          dealersFiltred: Object.values(this.getDistanceBetweenPlaces(this.props)).sort(function (a, b) {
            return a.Distance - b.Distance
          })
        })
      },
      error => {
        this.setState({
          error,
          isLoading: false
        })
        console.error('fail', error)
      }
    )
    this.setState({
      showFiltersPCLCV: this.props.store.listPremiumServices.some(item =>
        (item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL)
    })
    // GA Start
    window.dataLayer.push({
      brand: window.siteConfig.brandGTM,
      virtualPageURL: '/dealer-locator/search',
      pageName: window.siteConfig.pageName,
      language: window.siteConfig.language,
      country: window.siteConfig.currentCountry,
      siteTypeLevel1: window.siteConfig.siteTypeLevel1,
      siteTypeLevel2: 'appointement',
      siteOwner: 'central',
      siteTarget: 'B2C',
      siteFamily: 'after-sales',
      pageCategory: 'dealer locator page'
    })

    // GA Ends
    console.timeEnd('dataFetching')
    this.props.CurrentStepSetAction(1)
  }
  componentDidUpdate = (prevProps, prevState) => {
    //update the dealers list if the services

    if (!isEqual(this.props.store.filterDealersBy, prevProps.store.filterDealersBy)) {
      console.log('... UPDATE filters')
      this.filterDealers();
    }
    if (!isEqual(this.props.store.listPremiumServices, prevProps.store.listPremiumServices)) {
      this.setState({
        showFiltersPCLCV: this.props.store.listPremiumServices.some(item =>
          (item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL)
      })
    }
  }

  isMobile() {
    if (window.innerWidth <= 800) {
      return true
    } else {
      return false
    }
  }

  //filter the dealers with the user choice (services selected in filter)
  filterDealers = () => {
    let dealersFiltred = this.props.store.filterDealersBy.length > 0
      ? this.state.data.filter(dealer =>
        this.props.store.filterDealersBy.every(elemnt => dealer.ListeIdSP.includes(elemnt)))
      : this.state.data
    this.setState({ dealersFiltred: dealersFiltred })
    this.props.setListDealersFiltred(dealersFiltred)
  }

  getDistanceBetweenPlaces(urlProps = this.props) {
    let dealers = Object.assign({}, this.state.dealersFiltred)
    dealers = Object.values(dealers).map(function (dealer) {
      dealer.IsHover = false
      dealer.isInfosVisible = false
      const currentAdress = new google.maps.LatLng(window.siteConfig.defaultCountryGeo.lat, window.siteConfig.defaultCountryGeo.lng)
      const dealerLocation = new google.maps.LatLng(dealer.Latitude, dealer.Longitude)
      dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(2)
      return dealer
    })
    return dealers
  }

  markerIsHover(id) {
    this.markers[id].state.__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setIcon(_marker.iconActive)
  }

  markerNotHover(id) {
    this.markers[id].state.__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.setIcon(_marker.icon)
  }




  markerIsClicked(id) {
    const dealers = Object.assign({}, this.state.dealersFiltred)
    let selectedDealer = []
    for (var i = 0; i < Object.keys(dealers).length; i++) {
      // set other infoWindows to false(hide them)
      dealers[i].isInfosVisible = false
      if (dealers[i].DealerId === id) {
        dealers[i].IsHover = true
        selectedDealer = dealers[i]
        dealers[i].isInfosVisible = true
      }
    }

    this.setState({
      dealersFiltred: Object.values(dealers)
    })
    // Gmap.setCenter(new google.maps.LatLng(Number(selectedDealer.Latitude),Number(selectedDealer.Longitude) ));
    // Gmap.panTo(new google.maps.LatLng(Number(selectedDealer.Latitude),Number(selectedDealer.Longitude) ));
    Gmap.panTo(new google.maps.LatLng(Number(selectedDealer.Latitude), Number(selectedDealer.Longitude)))
    Gmap.panBy(0, -250)
  }



  handleMarkerRef(m, id) {
    if (m) {
      this.markers[id] = m
    }
  }

  hideInfoWindow() {
    const dealers = Object.assign({}, this.state.dealersFiltred)
    for (var i = 0; i < Object.keys(dealers).length; i++) {
      dealers[i].isInfosVisible = false
    }

    this.setState({ dealersFiltred: Object.values(dealers) })
  }

  handleMapMounted(map) {
    Gmap = map
  }
handleScroll(){
  if(window.siteConfig.currentBrand == 'V'){
    window.scrollTo({
      top: 135,
      behavior: "smooth"
    });
  }else{
    window.scrollTo({
    top: 140,
    behavior: "smooth"
  });
  }
  
}

  infoBoxRender(item) {
    return <InfoBox
      options={{
        closeBoxURL: '',
        enableEventPropagation: true,
        pixelOffset: new google.maps.Size(-130, -335),
        disableAutoPan: true,
        maxWidth: 0,
        boxStyle: {
          padding: '0px 0px 0px 0px',
          width: CONSTANTS.SITE_INFO.BRAND_CODE !== "C" ? '260px' : "auto",
          height: 'auto'
        }
      }}
    >
      <div className='dealerBoxInfo'>
        <span className='closeButton' onClick={this.hideInfoWindow} />

        <div className='dealer-details'>
          <h3 className='dealer-name'>{item.Name}</h3>
          <div>
            <div className='dealer-distance'>
              <i className='mark-icons location-icon' />
              <p> {item.Distance} Km </p>
            </div>
            <p className='dealer-adress'>
              {item.Address} <br />
              {item.ZipCode}  {item.City}
            </p>
            {this.state.showFiltersPCLCV && <div className='dealer-service'>
              {(item.LCV || item.PC) && <i className='mark-icons info-icon' />}
              <div>
                {(item.PC && !item.LCV) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_descriptive}</p> /*the dealer do only particular vehicles*/}
                {(item.LCV && !item.PC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_lcv_descriptive}</p>/*the dealer do only utilitaire vehicles*/}
                {(item.LCV && item.PC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_lvc_descriptive}</p> /*the dealer do both particular & utilitaire vehicles*/}
              </div>

            </div>}
          </div>
        </div>
        <Link
          //to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${item.City + '/' + slugify(item.Name) + '-_' + item.GeoId}?referrer=homepage`} className='mark-buttons button-filled' onClick={() => {
          to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(item.City) + '/' + slugify(item.Name) + '/' + item.GeoId}`} className='mark-buttons button-filled' onClick={() => {
            // event label remonte les informations du dealer choisi
            window.dataLayer.push({
              pageName: 'dealer locator',
              event: 'uaevent',
              eventCategory: 'Dealerlocator',
              eventAction: 'Redirection::Internal::DealerSchedule',
              eventLabel: item.Name

            })
            this.handleScroll()

          }}
        >
          {CONSTANTS.LABELS.dealer_locator_mapcta}
        </Link>
      </div>

    </InfoBox>
  }

  render() {
    const SEO_TITLE = (window.siteConfig.v2homepage != undefined ? window.siteConfig.v2homepage.Title : '')
    const SEO_DESC = (window.siteConfig.v2homepage != undefined ? window.siteConfig.v2homepage.MetaDescription : '')
    return (
      <div className='content-wrapper container-full-content'>
        {
          headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()),
            SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
        }
        <BodyClassName className='page--HomeMap' />

        {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && <p tabIndex="0" className='content-headline homePageMapHeadline' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.dealer_locator_maptitle) }}></p>}

        <MyMapComponent
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: (this.isMobile() ? '430px' : '650px') }} className={'map-container ' + this.state.stickyMap} />}
          mapElement={<div style={{ height: '100%' }} />}
          attDefaultCenter={{ lat: Number(this.state.map.lat), lng: Number(this.state.map.lng) }}
          attOptions={{ mapTypeControl: false, streetViewControl: false }}
          onMapMounted={this.handleMapMounted}
        >
          {this.state.dealersFiltred && this.state.dealersFiltred.map(function (item, key) {
            return <Marker
              position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
              title={item.Name}
              alt={item.Name}
              noRedraw
              ref={(m) => { this.handleMarkerRef(m, item.DealerId) }}
              icon={(item.IsHover ? new Object({
                url: _marker.iconActive,
                size: _marker.size,
                scaledSize: _marker.scaledSize,
                origin: _marker.origin
              })
                : new Object({
                  url: _marker.icon,
                  size: _marker.size,
                  scaledSize: _marker.scaledSize,
                  origin: _marker.origin
                }))}
              onMouseOver={window.siteConfig.currentBrand != 'D' ?
                (marker) => { this.markerIsHover(item.DealerId) }
                : ''
              }
              onClick={(marker) => {
                this.markerIsClicked(item.DealerId, true)
              }}
              onMouseOut={(marker) =>
                this.markerNotHover(item.DealerId)}

              key={item.DealerId}
            >

              {item.isInfosVisible && this.infoBoxRender(item)}

            </Marker>
          }.bind(this)
          )}

        </MyMapComponent>
      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(HomePageMap)
